import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { LocalserviceService } from '../../../api/localservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-itilogin',
  templateUrl: './itilogin.component.html',
  styleUrls: ['./itilogin.component.css']
})
export class ItiloginComponent implements OnInit {

  bdnuForm: any;
  submitted = false;
  public bool_spinner:boolean = false;

  reciveuserid:any;
  reciveMobilemo:any;
  reciveemail:any;
  reciveeITIcode:any;

  reciveuserstatus:any;
  reciveiticode:any;

  public bool_failure:boolean = false;
  public bool_success:boolean = false;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private httpClient: HttpClient, private Local: LocalserviceService) { }

  ngOnInit(): void {
    this.bdnuForm = this.formBuilder.group({
      userid: ['', Validators.required],
    });
  }

  get f() {
    return this.bdnuForm.controls;
  }

  onSubmit(){
    
    this.submitted = true;

    if (this.bdnuForm.invalid) {
      return;
    }
    this.bool_spinner = true;

    this.api.checkuserid(this.bdnuForm.value).subscribe((result: any) => {
      
      alert(JSON.stringify(result));
      this.bool_spinner = false;
      console.log(JSON.stringify(result))
      this.reciveuserid = result['userid'];
      this.reciveemail = result['email'];
      this.reciveMobilemo = result['mobile'];

        let args= {
          reciveuserid: this.reciveuserid,
          reciveemail: this.reciveemail,
          reciveMobilemo: this.reciveMobilemo
        };

      this.reciveuserstatus = result['status'];
      if(this.reciveuserstatus == 'success'){
       this.Local.set_login_data(args);      
       this.router.navigateByUrl('/examfeeiti/examitiotp');

      }
      else{
        alert('Fail Value')
        this.bool_failure = true;

        setTimeout(() => {
          this.bool_success = false;
          this.bool_failure = false;
        }, 5000);
      }
      let count:any = JSON.stringify(result.count);

      if(count == 1){
        console.log(JSON.stringify(result.email))
      }
    });
  }

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32 || k == 95);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}
